import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Split } from '../split';
export var LegendComponent =
/*#__PURE__*/
function (_Split) {
  _inherits(LegendComponent, _Split);

  function LegendComponent() {
    _classCallCheck(this, LegendComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(LegendComponent).apply(this, arguments));
  }

  return LegendComponent;
}(Split);